export default {
  namespaced: true,
  state: {
    languageList: localStorage.getItem("as-languageList")
      ? JSON.parse(localStorage.getItem("as-languageList")) ?? []
      : [],
    languageData: localStorage.getItem("as-languageData")
      ? JSON.parse(localStorage.getItem("as-languageData")) ?? []
      : [],
  },
  mutations: {
    initLanguageList(state, payload) {
      state.languageList = payload;
      localStorage.setItem("as-languageList", JSON.stringify(payload));
    },
    initLanguageData(state, payload) {
      state.languageData = payload;
      localStorage.setItem("as-languageData", JSON.stringify(payload));
    },
    updateLanguageList(state) {
      state.languageList =
        JSON.parse(localStorage.getItem("as-languageList")) ?? [];
    },
    updateLanguageData(state) {
      state.languageData =
        JSON.parse(localStorage.getItem("as-languageData")) ?? [];
    },
  },
};
